export const walletTypes = {
    CREATE_TRANSACTIONS: 'CREATE_TRANSACTIONS',
    GET_TRANSACTIONS: 'GET_TRANSACTIONS',
}